import React from 'react';
import Component from '@vfuk/core-card-sandwich-slot';
const CardSandwichSlot = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CardSandwichSlot;
